module.exports = __webpack_public_path__ + "static/media/northwestern 1.4e150d43.png";